import { type FC, useMemo } from 'react';
import { Route, Routes as Switch, Navigate } from 'react-router-dom';
import AuthRoutes from './AuthRoutes';
import PrivateRoutes from './PrivateRoutes';
import {
  authRoutes,
  privateRoutes,
  publicRoutes,
  setPrivateRoutes,
} from './Routes';
import { userRoles } from './Constant';
export interface RoutesConfigProps {
  updatePrivateRoutes?: boolean;
}
const RoutesConfig: FC<RoutesConfigProps> = (props): JSX.Element => {
  const { updatePrivateRoutes } = props;
  const privateRoutsUpdate = useMemo(() => {
    if (updatePrivateRoutes) {
      setPrivateRoutes();
      return privateRoutes;
    } else {
      return publicRoutes;
    }
  }, [updatePrivateRoutes]);

  return (
    <Switch>
      {updatePrivateRoutes && (
        <Route
          element={
            <PrivateRoutes
              expectedRoles={[userRoles.admin, userRoles.superAdmin]}
            />
          }
        >
          {privateRoutsUpdate.map(({ path, Component }, index) =>
            Component ? (
              <Route key={`${index}`} path={path} element={<Component />} />
            ) : null,
          )}
        </Route>
      )}

      {!updatePrivateRoutes && (
        <Route path="/" element={<Navigate to="/login" replace />} />
      )}

      {publicRoutes.map(({ path, Component }, index: number) => (
        <Route
          key={`${index}-${String(path)}`}
          path={path}
          element={<Component />}
        />
      ))}

      <Route element={<AuthRoutes />}>
        {authRoutes.map(({ path, Component }, index: number) =>
          Component ? (
            <Route
              key={`${index}-${String(path)}`}
              path={path}
              element={<Component />}
            />
          ) : null,
        )}
      </Route>
    </Switch>
  );
};

export default RoutesConfig;
